import {
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Typography,
} from '@material-ui/core';
import CheckRounded from '@material-ui/icons/CheckRounded';
import CloseIcon from '@material-ui/icons/Close';
import EmojiEventsOutlined from '@material-ui/icons/EmojiEventsOutlined';
import {
  BUTTON_BACKGROUND_COLOR,
  BUTTON_TEXT_COLOR,
  COMPANY_COLORS,
} from 'config/consts';
import PropTypes from 'prop-types';
import React from 'react';

const generalColor = COMPANY_COLORS.general.general_color;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CONTEUDO = {
  atividade: {
    texto: 'Parabéns você concluiu a atividade, avance para a seguinte! 🎉🎊',
    botao: 'AVANÇAR PARA A SEGUINTE',
    icone: CheckRounded,
  },
  jornada: {
    texto: 'Parabéns, você concluiu a sua jornada, veja o seu Ranking 👀',
    botao: 'VER MEU RANKING',
    icone: EmojiEventsOutlined,
  },
};

function JourneyDoneModal({ variant, onClose, onConfirm }) {
  const conteudo = CONTEUDO[variant];
  if (!conteudo) {
    return null;
  }

  const Icone = conteudo.icone;

  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="xs"
      PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}
    >
      <Box
        style={{
          height: 150,
          background: generalColor,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size="small"
          aria-label="fechar"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'rgba(255, 255, 255, 0.25)',
            color: '#fff',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            border: '2px solid rgba(255, 255, 255, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icone style={{ color: '#fff', fontSize: 36 }} />
        </Box>
      </Box>

      <Box style={{ padding: 24 }}>
        <Typography
          variant="h6"
          align="center"
          style={{ fontWeight: 'bold', marginBottom: 8 }}
        >
          {conteudo.texto}
        </Typography>

        <Button
          fullWidth
          onClick={onConfirm}
          style={{
            marginTop: 12,
            padding: '12px 0',
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 'bold',
            background: BUTTON_BACKGROUND_COLOR,
            color: BUTTON_TEXT_COLOR,
          }}
        >
          {conteudo.botao}
        </Button>
      </Box>
    </Dialog>
  );
}

JourneyDoneModal.propTypes = {
  variant: PropTypes.oneOf(['atividade', 'jornada']).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default JourneyDoneModal;
